import { React, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  //layout
  WithOutSideBarLayout,
  LogoImageLayout,

  //style
  TitleTextStyle,
  StyledBlueButton,
} from "common/components";
import { useLocation, useNavigate } from "react-router";
import { apiRequest } from "common/utils/api";
import { useTranslation } from "react-i18next";
import { TextInput } from "common/components/Input/TextInput";
import { DefaultButton } from "common/components/Button/new/DefaultButton";
import { colors } from "common/const/colors";
import { buttonHeight } from "common/const/const";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { PopUpScreen } from "common/views";

const VerifyPasswordScreen = () => {
  const { t } = useTranslation();
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const [failPopUp, setFailPopUp] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await apiRequest({
          method: REQUEST_METHOD.GET,
          url: "/api/v1.0/users",
        });
        methods.reset({
          email: response.data.result.email,
          password: "",
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchUser();
  }, []);

  const onSubmit = methods.handleSubmit(async (data) => {
    try {
      const response = await apiRequest({
        method: REQUEST_METHOD.POST,
        url: "/api/v1.0/sign-in",
        body: data,
        noRedirect: true,
      });
      navigate(location.state?.nextPage || -1, {
        state: { success: true },
        replace: true,
      });
    } catch (error) {
      console.log(error);
      setFailPopUp(true);
    } finally {
      const email = methods.getValues("email");
      methods.reset({ email: email, password: "" });
    }
  });

  return (
    <WithOutSideBarLayout>
      {failPopUp && (
        <PopUpScreen
          buttons={[
            <StyledBlueButton
              text={t("verify-password.text005")}
              mode="short"
              onClick={() => {
                setFailPopUp(false);
              }}
            />,
          ]}>
          <div>{t("verify-password.text004")}</div>
        </PopUpScreen>
      )}
      <LogoImageLayout>
        <img src={require("assets/logo/logo.png")} alt="logo" />
        <TitleTextStyle style={{ marginBottom: "2rem" }}>
          {t("verify-password.text001")}
        </TitleTextStyle>
        <FormProvider {...methods}>
          <TextInput
            name="password"
            type="password"
            placeholder={t("verify-password.text002")}
            rules={{
              required: {
                value: true,
                message: t("login.text005"),
              },
              minLength: {
                value: 8,
                message: t("login.text008"),
              },
            }}
          />
          <DefaultButton
            height={buttonHeight}
            fillColor={
              !methods.formState.isValid || methods.formState.isSubmitting
                ? colors.Gray
                : colors.MainBlue
            }
            textColor={colors.White}
            onClick={onSubmit}
            disabled={
              !methods.formState.isValid || methods.formState.isSubmitting
            }>
            {t("verify-password.text003")}
          </DefaultButton>
        </FormProvider>
      </LogoImageLayout>
    </WithOutSideBarLayout>
  );
};

export default VerifyPasswordScreen;
